import React, { Component } from 'react';
import { Routes, Route } from 'react-router-dom'; 
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTv, faPlug, faGear, faLayerGroup, faUsers } from '@fortawesome/free-solid-svg-icons'
import { SignIn } from './pages/SignIn.jsx';
import { EST } from './pages/ESMaintain.jsx'
import { SignUp } from './pages/SignUp.jsx';
import { Home } from './pages/Home.jsx'
import { Dashboard } from './pages/Dashboard.jsx'
import { DBMain } from './pages/DBMain'
import { CSDashboard } from './pages/CSDashboard.jsx'
import { CSDashboardMV } from './pages/CSDashboardMV.jsx'
import { FMDashboard } from './pages/FMDashboard.jsx'
import { FMDashboardQueues } from './pages/FMDashboardQueues.jsx'
import { FMDashboardAgents } from './pages/FMDashboardAgents.jsx'
import { TSDashboard } from './pages/TSDashboard.jsx'
import { TSDashboardMV } from './pages/TSDashboardMV.jsx'
import { About } from './pages/About.jsx'
import { Messages } from './pages/Messages.jsx'
import { RoutesT } from './pages/Routes.jsx'
import { Users } from './pages/Users.jsx'
import { Products } from './pages/Products.jsx';
import { Settings } from './pages/Settings.jsx';
import { Account } from './components/settings/Account.jsx';
import { Billing } from './components/settings/Billing.jsx';
import { Notifications } from './components/settings/Notifications.jsx';

// MSAL imports
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";

import { PublicClientApplication, EventType } from "@azure/msal-browser";

library.add(faTv, faPlug, faGear, faLayerGroup, faUsers);
const pca = new PublicClientApplication(msalConfig);
// Default to using the first account if no account is active on page load
if (!pca.getActiveAccount() && pca.getAllAccounts().length > 0) {
    // Account selection logic is app dependent. Adjust as needed for different use cases.
    pca.setActiveAccount(pca.getAllAccounts()[0]);
}

// Optional - This will update account state if a user signs in from another tab or window
pca.enableAccountStorageEvents();

// Listen for sign-in event and set active account
pca.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
        const account = event.payload.account;
        pca.setActiveAccount(account);
    }
});

const loginInfoDefault = {
    "success": false,
    "token": "",
    "message": "Not logged in",
    "emailAddress": "",
    "username": "",
    "userId": "",
    "userRights": {
        "AllowFileManage": false,
        "AllowRecordingManage": false,
        "AllowRoutingManage": false,
        "AllowUserManage": false
    }
};
const LoginInfoContext = React.createContext(loginInfoDefault);
const UpdateLoginInfoContext = React.createContext(undefined);

const GlobalStateProvider = ({ children }) => {
    const [loginInfo, updateLoginInfo] = React.useReducer( (loginInfo, newValue) => ({ ...loginInfo, ...newValue }),
    loginInfoDefault
    );
    return (
        <MsalProvider instance={pca}>
        <LoginInfoContext.Provider value={loginInfo}>
            <UpdateLoginInfoContext.Provider value={updateLoginInfo}>
                {children}
            </UpdateLoginInfoContext.Provider>
            </LoginInfoContext.Provider>
        </MsalProvider>
    );
};

export const useGlobalState = () => [
    React.useContext(LoginInfoContext),
    React.useContext(UpdateLoginInfoContext)
];

const App = () => {
    

    return (
        <GlobalStateProvider>
        <div className="App">
                <Routes>
                    <Route path="/" element={<SignIn />} />
                    <Route path="dbmain" element={<DBMain />} />
                    <Route path="csdashboard" element={<CSDashboard />} />
                    <Route path="csdashboardmv" element={<CSDashboardMV />} />
                    <Route path="fmdashboard" element={<FMDashboard />} />
                    <Route path="fmdashboardqueues" element={<FMDashboardQueues />} />
                    <Route path="fmdashboardagents" element={<FMDashboardAgents />} />
                    <Route path="tsdashboard" element={<TSDashboard />} />
                    <Route path="tsdashboardmv" element={<TSDashboardMV />} />
                    <Route path="/signup" element={<SignUp />} />
                    
                <Route path="/home" element={<Home />}>
                        <Route path="/home/dashboard" element={<Dashboard />} />
                        <Route path="/home/externalsystems" element={<EST />} />
                    <Route path="/home/about" element={<About />} />
                        <Route path="/home/messages" element={<Messages />} />
                        <Route path="/home/routes" element={<RoutesT />} />
                        <Route path="/home/users" element={<Users />} />
                    <Route path="/home/products" element={<Products />} />
                    <Route path="/home/settings" element={<Settings />} />
                    <Route path="/home/account" element={<Account />} />
                    <Route path="/home/billing" element={<Billing />} />
                    <Route path="/home/notifications" element={<Notifications />} />
                </Route>
            </Routes>

            </div>
        </GlobalStateProvider>
    );
}

export default App;

